<template>
    <drag-and-drop-endpoints
            :js-plumb-instance="jsPlumbInstance"
            
            :reference-parameters="referenceParameters"
            :endpoint-parameters="endpoints"

            @endpoints-updated="endpointsUpdated"

            @click="eventProxies.click"
            @dblclick="eventProxies.dblclick"
            @contextmenu="eventProxies.contextmenu"
            @mouseover="eventProxies.mouseover"
            @mouseout="eventProxies.mouseout"
            @mousedown="eventProxies.mousedown"
            @mouseup="eventProxies.mouseup"
            @maxConnections="eventProxies.maxConnections"
    >
        <slot />
    </drag-and-drop-endpoints>
</template>

<script>
    import journeyBrickEndpointUuidMixin from '../../Mixins/journey-brick-endpoint-uuid'
    import journeyBrickEndpointsMixin from '../../Mixins/journey-brick-endpoints'

    import DragAndDropEndpoints from "../../../../Components/DragAndDrop/DragAndDropEndpoints.vue";

    export default {
        name: 'journey-brick-circle-endpoints',
        components: {
            DragAndDropEndpoints
        },
        mixins: [journeyBrickEndpointUuidMixin, journeyBrickEndpointsMixin],
        created() {
            const vm = this;
            
            //Hide our endpoints
            vm.referenceParameters.endpoint = 'Blank';
            
            vm.sourceEndpointId = vm.getCircleEndpointUuid(vm.connectionId, vm.sourceBrickId);
            vm.destinationEndpointId = vm.getCircleEndpointUuid(vm.connectionId, vm.destinationBrickId);
        },
        methods: {
            endpointsUpdated($event){
                this.$emit('endpoints-updated', $event);

                //Our endpoints-updated event might destroy some endpoints
                //to avoid painting nothing; wait until the next tick
                this.$nextTick(() => this.applyConnectorStrokeColor());
            },
            applyConnectorStrokeColor(){
                const vm = this;
                const el = vm.$el;
                const jsPlumbInstance = vm.jsPlumbInstance;
                
                const stroke = vm.connectorStroke;

                jsPlumbInstance.batch(() => {
                    jsPlumbInstance.getEndpoints(el).forEach(endpoint => {
                        endpoint.connections.forEach(connection => {
                            //Re-use our old style; we only want to re-color
                            //When two endpoints belong to the same element;
                            //JsPlumb might return the same style object for all endpoints
                            //Create a new object to ensure we don't screw ourselves
                            const paintStyle = Object.assign({}, connection.getPaintStyle());
                            paintStyle.stroke = stroke;
                            connection.setPaintStyle(paintStyle);
                        });
                    });
                });
            }
        },
        watch: {
            connectorStroke(){
                this.applyConnectorStrokeColor();
            }
        },
        computed: {
            endpoints(){
                const vm = this;

                //Connections should not be detacheable, they'll get removed once the user removes
                //the circle brick
                
                return [{
                    uuid: vm.sourceEndpointId,
                    isTarget: true,
                    detachable: false
                }, {
                    uuid: vm.destinationEndpointId,
                    isSource: true,
                    detachable: false
                }];
            },
            connectorStroke(){
                return this.isActive ?
                    this.enabledConnectorStroke :
                    this.disabledConnectorStroke;
            }
        },
        data: () => ({
            referenceParameters: null,
            sourceEndpointId: '',
            destinationEndpointId: ''
        }),
        props: {
            connectionId: {
                type: String,
                required: true
            },
            isActive: {
                type: Boolean,
                required: true
            },
            sourceBrickId: {
                type: String,
                required: true
            },
            destinationBrickId: {
                type: String,
                required: true
            }
        }
    }
</script>
